import { createContext, useContext } from 'react';

export type DataLossHandler = (approved: boolean) => void;

export type DataLossContextType = {
  handler?: DataLossHandler | null;
  setHandler: (handler: DataLossHandler | null) => void;
};

export const DataLossContext = createContext<DataLossContextType>({
  setHandler: () => new Error('Not implemented'),
});

export const useDataLossContext = () => useContext(DataLossContext);
